import { createSlice } from "@reduxjs/toolkit";

export const previousSettingsSlice = createSlice({
  name: "previousSettingsSlice",
  initialState: {
    textColor: "#FFFFFF",
    textFont: 'Arial',
    shadowColor: "#000000",
    enableshadowColor: false
  },
  reducers: {
    setTextColor: (state, action) => {
      state.textColor = action.payload;
    },
    setTextFont: (state, action) => {
      state.textFont = action.payload;
    },
    setTextShadowColor: (state, action) => {
      state.shadowColor = action.payload;
    },
    setEnableTextShadowColor: (state, action) => {
      state.enableshadowColor = action.payload;
    },

  },
});

// Action creators are generated for each case reducer function
export const { setTextColor, setTextFont, setTextShadowColor, setEnableTextShadowColor } = previousSettingsSlice.actions;

export default previousSettingsSlice.reducer;
